import { createActions, handleActions } from 'redux-actions';

const actions = createActions({
    DEFAULT_TEXT: {
        FETCHING: undefined,
        FETCHED: defaultTexts => ({ defaultTexts }),
        SAVING: undefined,
        SAVED: () => ({}),
    },
});

const initialState = {
    error: null,
    fetching: false,
    defaultTexts: null,
    saving: false,
};

export default handleActions(
    {
        [actions.defaultText.fetching]: (state, action) =>
            Object.assign({}, initialState, {
                fetching: true,
            }),

        [actions.defaultText.fetched]: {
            next: (state, action) => {
                return Object.assign({}, initialState, {
                    fetching: false,
                    defaultTexts: action.payload.defaultTexts.reduce(
                        (result, defaultTextItem) => {
                            result[
                                defaultTextItem.defaultTextId
                            ] = defaultTextItem;
                            return result;
                        },
                        {}
                    ),
                });
            },
            throw: (state, action) => {
                return Object.assign({}, initialState, {
                    fetching: false,
                    error: true,
                });
            },
        },

        [actions.defaultText.saving]: (state, action) =>
            Object.assign({}, state, {
                saving: true,
            }),

        [actions.defaultText.saved]: {
            next: (state, action) =>
                Object.assign({}, state, {
                    saving: false,
                }),
            throw: (state, action) =>
                Object.assign({}, state, {
                    error: true,
                    saving: false,
                }),
        },
    },
    initialState
);

export const loadDefaultTexts = () => {
    return (dispatch, getState, api) => {
        dispatch(actions.defaultText.fetching());

        return api
            .get('/defaulttexts')
            .then(response => {
                dispatch(actions.defaultText.fetched(response.data.results));
            })
            .catch(err => {
                dispatch(actions.defaultText.fetched(err));
            });
    };
};

export const updateDefaultTexts = defaultTextItems => {
    return (dispatch, getState, api) => {
        dispatch(actions.defaultText.saving());

        return api
            .post('/defaulttexts/batchupdate', {
                defaultTextItems,
            })
            .then(response => {
                dispatch(actions.defaultText.saved(response.data.results));
            })
            .catch(err => {
                dispatch(actions.defaultText.saved(err));
            });
    };
};



// WEBPACK FOOTER //
// ./src/redux/reducers/defaulttext.js